/* global graphql */

import React from 'react';
import PorfolioItem from '../components/porfolio-item';

import '../static/css/css/all.css';


const PortfolioItem = (props) => {
  const decodeURLParams = (search) => {
    const hashes = search.slice(search.indexOf('?') + 1).split('&');
    return hashes.reduce((params, hash) => {
      const split = hash.indexOf('=');

      if (split < 0) {
        return Object.assign(params, {
          [hash]: null,
        });
      }

      const key = hash.slice(0, split);
      const val = hash.slice(split + 1);

      return Object.assign(params, { [key]: decodeURIComponent(val) });
    }, {});
  };

  const displayData = decodeURLParams(props.location.search);
  return (
    <main id="main-content">
      <PorfolioItem title={displayData.title} description={displayData.description} url={displayData.url} />
    </main>);
};

export default PortfolioItem;



// WEBPACK FOOTER //
// ./src/pages/portfolio-item.js